import Button from "@/components/Button/Button"
import Confirm from "@/components/Confirm/Confirm"
import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import { MODALS } from "@/constants/modals"
import { useRemoveFreeMaterialReviewMutation } from "@/queries/mutations/freeMaterialsMutations"
import {
  useFreeMaterialCourseReviews,
  useFreeMaterialData,
  useStudentFreeMaterialEnrollments,
} from "@/queries/queries/freeMaterialsQueries"
import { plusIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"
import { useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { toast } from "react-toastify"
import FreeMaterialReviewItem from "../FreeMaterialsReviews/FreeMaterialReviewItem"
import { CourseRatingStars } from "../FreeMaterialsReviews/FreeMaterialReviewStars"

export default function FreeMaterialCourseDetails() {
  const [removeOpen, setRemoveOpen] = useState(false)

  const { courseId } = useParams()
  const freeMaterialsQuery = useFreeMaterialData()
  const freeMaterialCourseReviewsQuery = useFreeMaterialCourseReviews(
    Number(courseId)
  )

  const studentFreeMaterialEnrollmentQuery = useStudentFreeMaterialEnrollments()
  const isStudentEnrolled = studentFreeMaterialEnrollmentQuery.data?.some(
    (enrollment) => enrollment.free_material_course_id === Number(courseId)
  )

  const myReview = freeMaterialCourseReviewsQuery.data?.myReview

  const course = freeMaterialsQuery.data?.data.find(
    (course) => course.id === Number(courseId)
  )

  const editModalState = useStore((store) => store.editModalState)

  const { t } = useTranslation()

  const removeReviewMutation = useRemoveFreeMaterialReviewMutation()

  if (!course) return null

  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex gap-3 my-2">
        <div className="object-fit-contain rounded-3 overflow-hidden">
          <img
            src={course?.image || "/public/assets/images/placeholder.png"}
            style={{ height: "200px" }}
          />
        </div>
        <div className="d-flex flex-column pb-4">
          <div className="mt-2">
            <p className="fs-2 fw-bold text-capitalize">{course.name}</p>
            <p className="fs-5 text-secondary">{course.description}</p>
          </div>
          <div className="mt-auto d-flex gap-2 align-items-center">
            <p className="fw-bold fs-5">{t("freeMaterialsPage.ratings")}</p>
            <div>
              <CourseRatingStars rating={course.avg_rating || 0} />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <div className="d-flex justify-content-between mt-1 mb-3">
          <p className="fs-2 fw-bold">{t("freeMaterialsPage.ratings")}</p>

          {(() => {
            if (!isStudentEnrolled) {
              return null
            } else if (!myReview && (course?.progress || 0) >= 25) {
              return (
                <Button
                  icon={plusIcon}
                  variant="primary"
                  onClick={() =>
                    editModalState(MODALS.freeMaterial.reviewsForm, true)
                  }
                >
                  {t("freeMaterialsPage.addReview")}
                </Button>
              )
            } else if (!myReview && (course?.progress || 0) < 25) {
              return (
                <Button
                  icon={plusIcon}
                  variant="primary"
                  onClick={() => toast.info(t("freeMaterialsPage.ratingToast"))}
                >
                  {t("freeMaterialsPage.addReview")}
                </Button>
              )
            } else {
              return null
            }
          })()}
        </div>
        {(() => {
          if (freeMaterialCourseReviewsQuery.isLoading) {
            return <Loading />
          } else if (
            freeMaterialCourseReviewsQuery.data?.reviews?.length === 0
          ) {
            return <NoMessage name={t("noMessages.reviews")} />
          } else {
            return (
              <Tabs
                defaultActiveKey="all-reviews"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab
                  eventKey="all-reviews"
                  title={t("freeMaterialsPage.allRatings")}
                >
                  <div className="px-3">
                    {freeMaterialCourseReviewsQuery.data?.reviews?.map(
                      (review) => (
                        <FreeMaterialReviewItem
                          key={review.id}
                          review={review}
                        />
                      )
                    )}
                  </div>
                </Tab>
                {isStudentEnrolled && (
                  <Tab
                    eventKey="my-review"
                    title={t("freeMaterialsPage.myRating")}
                  >
                    {myReview && (
                      <>
                        <div className="d-flex justify-content-between pe-3">
                          <FreeMaterialReviewItem review={myReview} />
                          {/* <div className="d-flex gap-2">
                          <IconOption
                            icon={editIcon}
                            tooltip={t("buttons.edit")}
                            onClick={() =>
                              editModalState(
                                MODALS.freeMaterial.reviewsForm,
                                myReview
                              )
                            }
                          />
                          <IconOption
                            deleteMod
                            icon={deleteIcon}
                            tooltip={t("buttons.delete")}
                            onClick={() => setRemoveOpen(true)}
                          />
                        </div> */}
                        </div>
                        <Confirm
                          isOpen={removeOpen}
                          setIsOpen={setRemoveOpen}
                          type="delete"
                          title={t("freeMaterialsPage.delete")}
                          confirmFunc={() =>
                            removeReviewMutation.mutate(myReview, {
                              onSuccess: () => setRemoveOpen(false),
                            })
                          }
                          loading={removeReviewMutation.isPending}
                        />
                      </>
                    )}
                  </Tab>
                )}
              </Tabs>
            )
          }
        })()}
      </div>
    </div>
  )
}
